import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faEdit, faShareSquare, faCloudDownloadAlt, faCloudUploadAlt, faMoneyBill, faClipboardCheck, faEye, faPlane, faInfoCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faUniversity, faCheckDouble } from '@fortawesome/free-solid-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';

import CoverRate from './CoverRate';
import TcsGstCharges from './Tcs_Gst_Charges';
import AddDetails from './AddDetails';
import PaymentApproval from './PaymentApproval';
import ComplianceApproval from './ComplianceApproval';
import BankFile from './BankFile';
import UploadSwift from './UploadSwift';
import DownloadSwift from './DownloadSwift';
import ShowPrintPreview from './ShowPrintPreview';
import ApiMaker from './ApiMaker';
import DialogYesNo from '../Dialog_Yes_No';
import BranchDetailVerify from './BranchVerifyDetails';

function InProgress() {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [entityType, setEntityType] = useState(sessionStorage.entityType);
    const [entityId, setEntityId] = useState(sessionStorage.entityId);

    const [showFilter, setShowFilter] = useState(true);
    const [showCvr, setShowCvr] = useState(false);
    const [showAddTcsGst, setShowAddTcsGst] = useState(false);
    const [showAddMoreDtl, setShowAddMoreDtl] = useState(false);
    const [showPaymentApproval, setShowPaymentApproval] = useState(false);
    const [showComplianceApproval, setShowComplianceApproval] = useState(false);
    const [showBranchDetailsVerify, setShowBranchDetailsVerify] = useState(false);
    const [showBmApproval, setShowBmApproval] = useState(false);
    const [showZmApproval, setShowZmApproval] = useState(false);
    const [showBhApproval, setShowBhApproval] = useState(false);

    const [showBankFileDown, setShowBankFileDown] = useState(false);
    const [showApiVerification, setShowApiVerification] = useState(false);

    const [showUploadDocument, setShowUploadDocument] = useState(false);
    const [showDownloadDocument, setShowDownloadDocument] = useState(false);
    const [showPrintPreview, setShowPrintPreview] = useState(false);



    const [rightCoverrate, setRightCoverrate] = useState([]);
    const [rightTcsUpdate, setRightTcsUpdate] = useState([]);
    const [rightAddDetails, setRightAddDetails] = useState([]);
    const [rightPayApprove, setRightPayApprove] = useState([]);
    const [rightComplianceApprove, setRightComplianceApprove] = useState([]);
    const [rightBranchDetailsVerify, setRightBranchDetailsVerify] = useState([]);
    const [rightBankFileApprove, setRightBankFileApprove] = useState([]);
    const [rightSwiftUpload, setRightSwiftUpload] = useState([]);
    const [rightSwiftDownload, setRightSwiftDownload] = useState([]);
    const [rightInvoiceUpload, setRightInvoiceUpload] = useState([]);
    const [rightInvoiceDownload, setRightInvoiceDownload] = useState([]);
    const [rightBmaprove, setRightBmaprove] = useState([]);
    const [rightZmaprove, setRightZmaprove] = useState([]);
    const [rightBhaprove, setRightBhaprove] = useState([]);
    const [rightApiMaker, setRightApiMaker] = useState([]);
    const [rightEmailSwiftInvoice, setRightEmailSwiftInvoice] = useState([]);
    const [rightSpecialApproval, setRightSpecialApproval] = useState([]);

    const [srchRef, setSrchRef] = useState("");
    const [srchToDate, setSrchToDate] = useState(new Date());
    const [srchFromDate, setSrchFromDate] = useState(new Date());
    const [srchStatus, setSrchStatus] = useState("ALL");
    const [ddReqStatusOptions, setDdReqStatusOptions] = useState([]);
    const [srchIssuer, setSrchIssuer] = useState(0);
    const [ddSrchIssuer, setDdSrchIssuer] = useState([]);
    const [showDownloadBankFileButton, setShowDownloadBankFileButton] = useState(false);
    const [srchAutoRefresh, setSrchAutoRefresh] = useState(false);
    const [srchExtraDetails, setSrchExtraDetails] = useState(false);


    const [tranListData, setTranListData] = useState([]);

    const [modalRef, setModalRef] = useState("");
    const [todayDateNum, setTodayDateNum] = useState(new Date().toISOString().slice(0, 10).replace('-', '').replace('-', ''));

    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);

    const [reqBranch, setReqBranch] = useState("0");
    const [ddReqBranchOptions, setDdReqBranchOptions] = useState([]);


    const [srchBran, setSrchBran] = useState("0");
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBranSelect, setSrchBranSelect] = useState([]);


    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);

    const [openConfirmBox, setOpenConfirmBox] = useState(false);
    const [confirmBoxMsg, setConfirmBoxMsg] = useState("");
    const [swiftInvoiceRequestStatus, setSwiftInvoiceRequestStatus] = useState("");

    // PAN LOg Screen    
    const [panNum, setPanNum] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setPanNum('');
        setMessage('');
    }
    const [showPanData, setShowPan] = useState(false);
    const handleClosePan = () => setShowPan(false);
    const [panLog, setPanLog] = useState([]);
    const [message, setMessage] = useState('');

    const [openChangeCoverValidity, setOpenChangeCoverValidity] = useState(false);
    const [cashDate, setCashDate] = useState(new Date());
    const [tomDate, setTomDate] = useState(new Date());
    const [spotDate, setSpotDate] = useState(new Date());

    // Cn Card States
    const [openCnCardModal, setOpenCnCardModal] = useState(false);
    const [ddReqBranchOptionsAllowed, setDdReqBranchOptionsAllowed] = useState([]);
    const [rightCnCard, setRightCnCard] = useState([]);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [reqBranchAllowed, setReqBranchAllowed] = useState("0");
    const [reqReference, setReqReference] = useState("A");
    const [reqAgentAllowed, setReqAgentAllowed] = useState("0");
    const [ddReqAgentOptionsAllowed, setDdReqAgentOptionsAllowed] = useState([]);
    const [reqProductCnCard, setReqProductCnCard] = useState("CNCARD");
    const [invAmountCnCard, setInvAmountCnCard] = useState("");
    const [reqLoanAccountNo, setReqLoanAccountNo] = useState("");
    const [reqLoanApplicant, setReqLoanApplicant] = useState("");
    const [reqLoanApplicantPassport, setReqLoanApplicantPassport] = useState("");
    const [reqLoanApplicantPan, setReqLoanApplicantPan] = useState("");
    const [reqLoanCoApplicant, setReqLoanCoApplicant] = useState("");
    const [reqLoanCoApplicantPassport, setReqLoanCoApplicantPassport] = useState("");
    const [reqLoanCoApplicantPan, setReqLoanCoApplicantPan] = useState("");

    const [isMsgBoxCnCard, setMsgBoxCnCard] = useState(false);
    const [msgTextCnCard, setMsgTextCnCard] = useState("");

    const [reqPayBankCode, setReqBankCode] = useState("0");
    const [ddReqPayBankOptions, setDdReqPayBankOptions] = useState([]);
    const [reqPayBankName, setReqBankName] = useState("");
    const [reqPayBankRefNo, setReqPayBankRefNo] = useState("");
    const [reqPayBankAmnt, setReqPayBankAmnt] = useState(0);
    const [reqPayBankDate, setReqPayBankDate] = useState(new Date());
    const [payListDataCnCard, setPayListDataCnCard] = useState([]);
    const [reqDateCnCard, setReqDateCnCard] = useState(new Date());

    const [filterTTCheck, setFilterTTCheck] = useState(true);
    const [filterCnCardCheck, setFilterCnCardCheck] = useState(false);
    const [uploadRight, setUploadRight] = useState('');
    const [showUpload, setShowUpload] = useState(false);
    const [file, setFile] = useState(null);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {

            Common.callApi(Common.apiRight, [sid, 'all', 'INPROGRESS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    // #region calculation cover validity

                    if (sessionStorage.coverCashValidity === undefined) {
                        sessionStorage.coverCashValidity = Common.getFutureDateDMY(1);
                    }
                    if (sessionStorage.coverTomValidity === undefined) {
                        sessionStorage.coverTomValidity = Common.getFutureDateDMY(2);
                    }
                    if (sessionStorage.coverSpotValidity === undefined) {
                        sessionStorage.coverSpotValidity = Common.getFutureDateDMY(3);;
                    }
                    // #endregion
                    /*Common.callApi(Common.apiRight,[sid,'allrightquery'],function(result){
                        setUserAllQueryRight(JSON.parse(result));
                    });*/
                    Common.callApi(Common.apiRight, [sid, 'all', 'COVERRATE'], function (result1) {
                        var tempCoverRate = JSON.parse(result1);
                        setRightCoverrate(tempCoverRate);

                        if (entityType === "B") {
                            if (tempCoverRate.add === "1") {  // rightCoverrate.add === "1"
                                {/* { "value": "ACVR", "name": "Add Cover Revised" },  */ }
                                setDdReqStatusOptions(
                                    [
                                        { "value": "ALL", "name": "ALL" },
                                        { "value": "ACV", "name": "Add Cover All" },
                                        { "value": "ACVN", "name": "Add Cover Quick" },
                                        { "value": "ACH", "name": "Add Charges" },
                                        { "value": "ADT", "name": "Add Details" },
                                        { "value": "VPAY", "name": "Verify Payment" },
                                        { "value": "VBRCH", "name": "Branch Details Verify" },
                                        { "value": "VCOMP", "name": "Verify Details" },
                                        { "value": "SNAVR", "name": "Seen and Verify" },
                                        { "value": "BNKF", "name": "Bank File" },
                                        { "value": "UPLS", "name": "Upload Swift" },
                                        { "value": "UPLI", "name": "Upload Invoice" },
                                        { "value": "DOWN", "name": "Downloads" },
                                        { "value": "PROC", "name": "Processed" },
                                        { "value": "NPROC", "name": "Not Processed" },
                                        { "value": "SPAYL", "name": "Send Payment Link" }
                                    ]
                                );
                            } else {
                                setDdReqStatusOptions(
                                    [
                                        { "value": "ALL", "name": "All" },
                                        { "value": "ACH", "name": "Add Charges" },
                                        { "value": "ADT", "name": "Add Details" },
                                        { "value": "VPAY", "name": "Verify Payment" },
                                        { "value": "VBRCH", "name": "Branch Details Verify" },
                                        { "value": "VCOMP", "name": "Verify Details" },
                                        { "value": "SNAVR", "name": "Seen and Verify" },
                                        { "value": "BNKF", "name": "Bank File" },
                                        { "value": "UPLS", "name": "Upload Swift" },
                                        { "value": "UPLI", "name": "Upload Invoice" },
                                        { "value": "DOWN", "name": "Downloads" },
                                        { "value": "PROC", "name": "Processed" },
                                        { "value": "NPROC", "name": "Not Processed" },
                                        { "value": "SPAYL", "name": "Send Payment Link" }
                                    ]
                                );
                            }
                            Common.callApi(Common.apiUser, [sid, 'branchallowedall'], function (result) {
                                let resp1 = JSON.parse(result);
                                setDdReqBranchOptions(resp1);
                                if (resp1.length === 2) {
                                    setReqBranch(resp1[1].value);
                                }
                            });
                            Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                                let resp2 = JSON.parse(result);
                                setDdSrchBranOptions(resp2);
                                if (resp2.length === 2) {
                                    setSrchBranSelect(resp2[1]);
                                    setSrchBran(resp2[1].value);
                                    console.log(resp2);
                                }
                            });

                        } else {
                            setDdReqStatusOptions(
                                [
                                    { "value": "ALL", "name": "All" },
                                    { "value": "ADT", "name": "Add Details" },
                                    { "value": "DOWN", "name": "Downloads" },
                                    { "value": "PROC", "name": "Processed" },
                                    { "value": "NPROC", "name": "Not Processed" }
                                ]
                            );
                        }


                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'TCSFINAL'], function (result2) {
                        setRightTcsUpdate(JSON.parse(result2));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'ADDDETAILS'], function (result3) {
                        setRightAddDetails(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'PAYAPROVE'], function (result3) {
                        setRightPayApprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'COMPAPROVE'], function (result3) {
                        setRightComplianceApprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'BRANCH_VERIFY_DETAILS'], function (result3) {
                        setRightBranchDetailsVerify(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'BANKFILE'], function (result3) {
                        setRightBankFileApprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'SWIFTUPLOAD'], function (result3) {
                        setRightSwiftUpload(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'SWIFTDOWNLOAD'], function (result3) {
                        setRightSwiftDownload(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INVOICEUPLOAD'], function (result3) {
                        setRightInvoiceUpload(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'INVOICEDOWNLOAD'], function (result3) {
                        setRightInvoiceDownload(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'BMAPROVE'], function (result3) {
                        setRightBmaprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'ZMAPROVE'], function (result3) {
                        setRightZmaprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'BHAPROVE'], function (result3) {
                        setRightBhaprove(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'BANKAPIMAKER'], function (result3) {
                        setRightApiMaker(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'EMAILSWIFTINVOICE'], function (result3) {
                        setRightEmailSwiftInvoice(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'SPECIALAPPROVAL'], function (result3) {
                        setRightSpecialApproval(JSON.parse(result3));
                    });
                    Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                        setDdSrchIssuer(JSON.parse(result));
                    });
                    Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                        setDdReqAgentOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'NEWREQUEST_CN_VTM'], function (result4) {
                        let resp = JSON.parse(result4)
                        setRightCnCard(resp);
                        if (resp.query == 1)
                            onChangeRefrence("A");
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'REMITTANCE_CHARGES_UPLOAD'], function (result5) {
                        let resp = JSON.parse(result5)
                        setUploadRight(resp);
                    });

                    if (sessionStorage.entityType === "B") {
                        Common.callApi(Common.apiUser, [sid, 'branchallowed'], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptionsAllowed(resp);
                            if (resp.length === 2) {
                                handleBranchChangeCnCard(resp[1].value);
                            }
                        });
                    } else if (entityType === "A") {
                        setReqReference("A");
                        Common.callApi(Common.apiEntity, [sid, 'agentbranchlink', sessionStorage.entityId], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptionsAllowed(resp.oneBranch);
                            handleBranchChangeCnCard(resp.oneBranch[0].value);
                            setReqAgentAllowed(resp.oneAgent[0].value);
                        });

                    }

                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttall'], function (result) {
                setDdReqPurposeOptions(JSON.parse(result));
            });
            localStorage.clear();  // Deletes all local storage data
            /*Common.callApi(Common.apiRequestStatus, [sid, 'ddlistjson'], function (result) {
                setDdReqStatusOptions(JSON.parse(result));
            });*/

            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, entityType]);

    function fetchPanData() {

        if (!panNum) {
            setMessage('Fill PAN');
        } else {
            const obj = {
                panNum: panNum
            }

            Common.callApi(Common.apiInProgress, [sid, "viewPanLog", JSON.stringify(obj)], result => {
                const res = JSON.parse(result);
                console.log(res);
                setPanLog(res);
                setShow(false);
                setShowPan(true);
            });
        }
    }

    function handleAutoRefresh() {
        clearInterval(sessionStorage.myInterval);
        if (!srchAutoRefresh) {
            sessionStorage.myInterval = setInterval(() => document.getElementById("btnSearchRequest").click(), 30000);
        }
        setSrchAutoRefresh(!srchAutoRefresh);

    }

    function handleExtraDetails() {
        setSrchExtraDetails(!srchExtraDetails);
    }

    function searchRequest(v) {
        var srchFlag = true;
        if (srchStatus === "ACVN" && v === 1) {
            $('.QuickDeal').each(function () {
                if ($(this).val().trim() !== '') {
                    srchFlag = false;
                }
            });
        }

        if (srchFlag) {
            $('.loader').show();
            if (srchFromDate !== '' && srchToDate === '') {
                setSrchToDate(srchFromDate);
            }
            if (srchToDate !== '' && srchFromDate === '') {
                setSrchFromDate(srchToDate);
            }
            var daysDiff = Math.round((srchToDate - srchFromDate) / (1000 * 24 * 60 * 60));
            if (daysDiff < 0) {
                $('.loader').hide();
                setMsgText("From Date should be less than To Date.");
                setMsgBox(true);
            } else if (daysDiff > 30) {
                $('.loader').hide();
                setMsgText("Maximum 31 days allowed for listing.");
                setMsgBox(true);
            } else {
                /*
                       else if (srchIssuer * 1 === 0 && srchStatus === "BNKF") {
                   $('.loader').hide();
                   setMsgText("Please check Valid Bank (Issuer).");
                   setMsgBox(true);
               }
                */
                // reqBranch
                const trimSrchRef = srchRef?.trim();
                var object1 = {
                    srchStatus: srchStatus,
                    srchFromDate: Common.dateYMD(srchFromDate),
                    srchToDate: Common.dateYMD(srchToDate),
                    srchRef: trimSrchRef,
                    srchIssuer: srchIssuer,
                    reqPurpose: reqPurpose,
                    reqBranch: srchBran,
                    reqAgent: reqAgent,
                    filterTTCheck: filterTTCheck,
                    filterCnCardCheck: filterCnCardCheck
                };
                setTranListData([]);
                Common.callApi(Common.apiInProgress, [sid, 'listjson', JSON.stringify(object1)], function (result) {
                    let resp = JSON.parse(result);
                    if (resp.status === "MSG0002") {
                        navigate('/');
                    }
                    setTranListData(resp);
                    $('.loader').hide();

                    setRefreshCounter(refreshCounter + 1);
                    // console.log(new Date() + " Refresh List");
                    Common.setPageTitle(resp.length);
                });
                if (rightBankFileApprove.query === "1" && srchStatus === "BNKF" && srchIssuer * 1 > 0) {
                    setShowDownloadBankFileButton(true);
                } else {
                    setShowDownloadBankFileButton(false);
                }
            }
        }
    }

    function handleSetSrchIssuer(v) {
        setSrchIssuer(v);
        setShowDownloadBankFileButton(false);
    }
    function resetSearch() {
        setSrchStatus(0);
        setSrchFromDate("");
        setSrchToDate("");
        setSrchRef("");
        setEntityType(entityType);  // just to remove warning in build. no require code.
    }
    function showFilterWindow() {
        searchRequest(1);
        setShowFilter(true);
        setShowCvr(false);
        setShowAddTcsGst(false);
        setShowAddMoreDtl(false);
        setShowBankFileDown(false);
        setShowApiVerification(false);
        setShowPaymentApproval(false);
        setShowComplianceApproval(false);
        setShowBranchDetailsVerify(false);
        setShowDownloadDocument(false);
        setShowUploadDocument(false)
        setShowPrintPreview(false);
        setShowBmApproval(false);
        setShowZmApproval(false);
        setShowBhApproval(false);
    }

    function showPrintPreviewWindow(v) {
        setModalRef(v);
        setShowPrintPreview(true);
        setShowFilter(false);
    }
    function showCoverWindow(v) {
        setModalRef(v);
        setShowCvr(true);
        setShowFilter(false);
    }
    function showTcsGstWindow(v) {

        setModalRef(v);
        setShowAddTcsGst(true);
        setShowFilter(false);
    }

    function showAddMoreDtlWindow(v) {
        setModalRef(v);
        setShowAddMoreDtl(true);
        setShowFilter(false);
    }

    function showBmApprovalWindow(v) {
        setModalRef(v);
        setShowBmApproval(true);
        setShowFilter(false);
    }

    function showZmApprovalWindow(v) {
        setModalRef(v);
        setShowZmApproval(true);
        setShowFilter(false);
    }

    function showBhApprovalWindow(v) {
        setModalRef(v);
        setShowBhApproval(true);
        setShowFilter(false);
    }

    function showPaymentApprovalWindow(v) {
        setModalRef(v);
        setShowPaymentApproval(true);
        setShowFilter(false);
    }

    function showComplianceApprovalWindow(v) {
        setModalRef(v);
        setShowComplianceApproval(true);
        setShowFilter(false);
    }

    function showBranchDetailsVerifyWindow(v) {
        setModalRef(v);
        setShowBranchDetailsVerify(true);
        setShowFilter(false);
    }

    function showBankFileDownWindow(v) {
        setModalRef(v);
        setShowBankFileDown(true);
        setShowFilter(false);
    }

    function showApiVerificationWindow(v) {
        setModalRef(v);
        setShowApiVerification(true);
        setShowFilter(false);
    }


    function showFinalDocumentDownload(v) {
        setModalRef(v);
        setShowDownloadDocument(true);
        setShowFilter(false);
    }
    function showFinalDocumentUpload(v) {
        setModalRef(v);
        setShowUploadDocument(true);
        setShowFilter(false);
    }



    function downloadBankFile() {
        let selectedSrno = ""
        $('.selectorChkBox').each(function () {
            if ($(this).is(':checked')) {
                if (selectedSrno === "") {
                    selectedSrno = $(this).val();
                } else {
                    selectedSrno = selectedSrno + "," + $(this).val();
                }
            }
        });
        if (selectedSrno !== "") {
            Common.callDownloadApiPost(Common.apiBankFile, "post", [sid, 'onebankfile', selectedSrno]);
        } else {
            setMsgText("Please select few remittances.");
            setMsgBox(true);
        }

    }

    function selectAllToggle(v) {
        if (v) {
            $('.selectorChkBox').attr('checked', true);
        } else {
            $('.selectorChkBox').attr('checked', false);
        }
    }

    function quickCoverFinal(srno) {
        $('.loader').show();
        if (parseFloat($('#DealRate' + srno).val()) !== $('#DealRate' + srno).val() * 1) {
            $('.loader').hide();
            setMsgText("Please input valid Deal Rate.");
            setMsgBox(true);
        } else if ($('#DealId' + srno).val() === "") {
            $('.loader').hide();
            setMsgText("Please input valid Deal number.");
            setMsgBox(true);
        } else {
            var d = new Date($('#DealIdValDt' + srno).val());
            d.setDate(d.getDate());
            var obj = {
                srno: srno,
                valDate: d,
                cvalue: $('#DealQty' + srno).val(),
                tenure: $('#DealTenure' + srno).val(),
                bankId: $('#DealBankId' + srno).val(),
                dealId: $('#DealId' + srno).val(),
                dealRate: $('#DealRate' + srno).val()
            }
            Common.callApi(Common.apiCover, [sid, 'quickcoverfinal', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    $('.loader').hide();
                    setRefreshCounter(refreshCounter + 1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    searchRequest(2);

                } else {
                    $('.loader').hide();
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
            // alert(JSON.stringify(obj));
        }
    }

    function onChangeSearchStatus(v) {
        setSrchStatus(v);
        setSrchRef("");
        if (entityType === 'B' && ddReqBranchOptions.length > 2 && (v === "ACV" || v === "ACVN")) {
            setReqBranch(0);
            setReqPurpose(0);
        }
        setTranListData([]);
        setRefreshCounter(refreshCounter + 1);
    }

    function handleKeyDown(e) {
        setTranListData([]);
        if (e.keyCode === 13) {
            searchRequest(1);
        }
    }

    function calcSummary() {
        var arr = [];
        $('.ACVNSummary').each(function () {
            if ($(this).val().trim() !== '') {
                var item = $(this).val().split("^")
                if (arr[item[0] + " (" + item[1] + ")"] === undefined) {
                    arr[item[0] + " (" + item[1] + ")"] = item[2];
                } else {
                    arr[item[0] + " (" + item[1] + ")"] = ((arr[item[0] + " (" + item[1] + ")"]) * 1 + (item[2]) * 1).toFixed(2);
                }
            }
        });
        var msg = "Pending Cover to be taken :\n\n";
        for (const key in arr) {
            msg = msg + key + " : " + arr[key] + "\n";
        }
        msg = msg + "\n*Revised not included";
        alert(msg);
    }

    function handleSrchBranchOptions(v) {
        setSrchBranSelect(v);
        setSrchBran(v.value);
    }

    function noCoverViewAgent() {
        if (sessionStorage.nocoverviewagent === "1") {
            return true;
        } else {
            return false;
        }
    }

    function showSearchOptions() {
        setMsgText("Search on : Serial Number, Reference Number, PAN, Name on PAN, Remitter Name, Loan Account Number, AD2 Number");
        setMsgBox(true);
    }

    function autoInvoiceEmailRequest() {
        var i = 0, msg = [];
        if (reqAgent === "0" || srchBran === "0") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqAgent === "0" ? "Agent" : "");
            msg[i++] = (srchBran === "0" ? "Branch" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (reqAgent != 13) {
            setMsgBox(true);
            setMsgText("Ony Avanse agent is allowed.");
        } else {
            const obj1 = {
                reqAgent: reqAgent,
                srchBran: srchBran,
                srchFromDate: Common.dateYMD(srchFromDate)
            }
            Common.callApi(Common.apiInvoiceEmailReq, [sid, "reqemail", JSON.stringify(obj1)], result => {
                var msg = "";
                let resp = JSON.parse(result);
                let confirmModal = 0;
                setSwiftInvoiceRequestStatus(resp.status);
                if (resp.status === "O") {
                    confirmModal = 1;
                    msg = "Do you want to request an auto-email to " + resp.entityname + " from " + srchBranSelect.label + " for date " + Common.dateDMY(srchFromDate) + ".";
                }
                else if (resp.status === "P") msg = "There is already a pending request of " + srchBranSelect.label + " for date " + Common.dateDMY(srchFromDate) + ".";
                else if (resp.status === "I") msg = "The request with branch " + srchBranSelect.label + " and date " + Common.dateDMY(srchFromDate) + " is in progress. Please try again later.";
                else if (resp.status === "D") {
                    confirmModal = 1;
                    msg = "The email with branch " + srchBranSelect.label + " and date " + Common.dateDMY(srchFromDate) + " has already been sent. Do you want to add a request again.";
                }
                else msg = "";
                if (confirmModal === 1) {
                    setOpenConfirmBox(true);
                    setConfirmBoxMsg(msg);
                } else {
                    setMsgBox(true);
                    setMsgText(msg);
                }
            });
        }
    }


    function handleConfirmBox() {
        $(".loader").show();
        const obj1 = {
            reqAgent: reqAgent,
            srchBran: srchBran,
            srchFromDate: Common.dateYMD(srchFromDate)
        }
        Common.callApi(Common.apiInvoiceEmailReq, [sid, "confirmreq", JSON.stringify(obj1)], result => {
            var msg = "";
            let resp = JSON.parse(result);
            $(".loader").hide();
            if (resp === "0") msg = "Request has been saved.";
            else msg = "Invoice is not uploaded for srno " + resp + ".";

            setOpenConfirmBox(false);
            setMsgBox(true);
            setMsgText(msg);
        });
    }

    function goToSpecialApproval() {
        navigate('/specialapproval');
    }


    function changeCoverValidityDate() {
        setCashDate(new Date(sessionStorage.coverCashValidity));
        setTomDate(new Date(sessionStorage.coverTomValidity));
        setSpotDate(new Date(sessionStorage.coverSpotValidity));
        setOpenChangeCoverValidity(true);
    }

    function handleChangeCoverValidity() {
        sessionStorage.coverCashValidity = cashDate.toISOString().split('T')[0];
        sessionStorage.coverTomValidity = tomDate.toISOString().split('T')[0];
        sessionStorage.coverSpotValidity = spotDate.toISOString().split('T')[0];
        setOpenChangeCoverValidity(false);
        searchRequest(1);
    }

    function goToCnCard() {
        setOpenCnCardModal(true);
        resetCnCardModal();
    }

    function onChangeRefrence(id) {
        if (id === "S") {
            setReqAgentAllowed("0");
        }
        setReqReference(id);
        if (id === "A") {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                setDdReqAgentOptionsAllowed(JSON.parse(result));
            });
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagent', 0], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        }
    }

    function onSubmitCnCard() {
        var msg = [], i = 0;
        if (reqBranchAllowed == "0" || reqAgentAllowed === "0" || invAmountCnCard === "" || invAmountCnCard === "0" || reqDateCnCard == null ||
            (reqAgentAllowed == "13" && (reqLoanAccountNo === "" || reqLoanApplicant === "" || reqLoanApplicantPassport === "" || reqLoanApplicantPan === ""
                || reqLoanCoApplicant === "" || reqLoanCoApplicantPassport === "" || reqLoanCoApplicantPan === ""))
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqDateCnCard == null ? "Request Date" : "");
            msg[i++] = (reqBranchAllowed === "0" ? "Branch" : "");
            msg[i++] = (reqAgentAllowed === "0" ? "Agent" : "");
            msg[i++] = ((invAmountCnCard === "0" || invAmountCnCard === "") ? "Invoice Amount" : "");
            if (reqAgentAllowed == "13") {
                msg[i++] = (reqLoanAccountNo === "" ? "Loan Acct Num" : "");
                msg[i++] = (reqLoanApplicant === "" ? "Loan Applicant" : "");
                msg[i++] = (reqLoanApplicantPassport === "" ? "Loan applicant passport" : "");
                msg[i++] = (reqLoanApplicantPan === "" ? "Loan Applicant PAN" : "");
                msg[i++] = (reqLoanCoApplicant === "" ? "Loan Co Applicant" : "");
                msg[i++] = (reqLoanCoApplicantPassport === "" ? "Loan co appplicant passport " : "");
                msg[i++] = (reqLoanCoApplicantPan === "" ? "Loan co applicant PAN" : "");
            }
            setMsgBoxCnCard(true);
            setMsgTextCnCard(Common.buildMessageFromArray(msg));
            setOpenCnCardModal(false);
        } else {
            if (reqAgentAllowed == "13") {
                const obj = {
                    key: Common.getRandomString(),
                    pay_bankcode: reqPayBankCode,
                    pay_bankname: reqPayBankName,
                    pay_refno: "POSTPAID",
                    pay_amnt: invAmountCnCard,
                    pay_date: Common.dateYMD(reqDateCnCard)
                }
                setPayListDataCnCard(Common.arrayAddItem(payListDataCnCard, obj));
            }
            setMsgBoxYN(true);
            setOpenCnCardModal(false);
            setMsgTextYN("Do you confirm to save changes.");
        }
    }

    function saveDataCnCard() {
        const obj = {
            reqBranchAllowed: reqBranchAllowed,
            reqAgentAllowed: reqAgentAllowed,
            reqReference: reqReference,
            reqProductCnCard: reqProductCnCard,
            invAmountCnCard: invAmountCnCard,
            reqLoanAccountNo: reqLoanAccountNo,
            reqLoanApplicant: reqLoanApplicant,
            reqLoanApplicantPassport: reqLoanApplicantPassport,
            reqLoanApplicantPan: reqLoanApplicantPan,
            reqLoanCoApplicant: reqLoanCoApplicant,
            reqLoanCoApplicantPassport: reqLoanCoApplicantPassport,
            reqLoanCoApplicantPan: reqLoanCoApplicantPan,
            payListDataCnCard: payListDataCnCard,
            reqDateCnCard: Common.dateYMD(reqDateCnCard)
        }
        Common.callApi(Common.apiNewRequestCnCard, [sid, "savedata", JSON.stringify(obj)], result => {
            let res = JSON.parse(result);
            if (res.err !== "") {
                setOpenCnCardModal(false);
                setMsgBoxCnCard(true);
                setMsgTextCnCard(res.err);
                if (reqAgentAllowed === "13") setPayListDataCnCard([]);
            } else {
                setOpenCnCardModal(false);
                searchRequest(1);
                resetCnCardModal();
            }
        });
        setMsgBoxYN(false);
    }

    function resetCnCardModal() {
        setReqAgentAllowed("0");
        setReqLoanAccountNo("");
        setReqLoanApplicant("");
        setReqLoanApplicantPassport("");
        setReqLoanApplicantPan("");
        setReqLoanCoApplicant("");
        setReqLoanCoApplicantPassport("");
        setReqLoanCoApplicantPan("");
        setInvAmountCnCard("");
        setPayListDataCnCard([]);
        setReqBankCode("0");
        setReqPayBankRefNo("");
        setReqPayBankAmnt("");
        setReqPayBankDate(new Date());
        setReqDateCnCard(new Date());
    }

    function handleBranchChangeCnCard(v) {
        setReqBranchAllowed(v);
        if (v === "0" || v === "") {
            setDdReqPayBankOptions([]);
            return;
        }
        Common.callApi(Common.apiBank, [sid, 'ddlistjsonbranchwise', v], function (result3) {
            setDdReqPayBankOptions(JSON.parse(result3));
        });
    }

    function handleReqPayBank(v, t) {
        setReqBankCode(v);
        setReqBankName(t);
    }

    function btnAddPayment() {
        $(".loader").show();
        var msg = [], i = 0;
        if (reqPayBankCode == "0" || reqPayBankCode === "" || reqPayBankRefNo === "" || reqPayBankAmnt === "" || reqPayBankDate == null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((reqPayBankCode == "0" || reqPayBankCode === "") ? "Bank" : "");
            msg[i++] = (reqPayBankRefNo === "" ? "Bank Reference" : "");
            msg[i++] = (reqPayBankAmnt === "" ? "Amount" : "");
            msg[i++] = (reqPayBankDate === null ? "Pay Date" : "");
            setMsgBoxCnCard(true);
            setMsgTextCnCard(Common.buildMessageFromArray(msg));
            setOpenCnCardModal(false);
        } else {
            $(".loader").hide();
            const obj = {
                key: Common.getRandomString(),
                pay_bankcode: reqPayBankCode,
                pay_bankname: reqPayBankName,
                pay_refno: reqPayBankRefNo,
                pay_amnt: reqPayBankAmnt,
                pay_date: Common.dateYMD(reqPayBankDate)
            }
            setPayListDataCnCard(Common.arrayAddItem(payListDataCnCard, obj));
            setReqPayBankAmnt("");
            setReqBankCode("0");
            setReqBankName("");
            setReqPayBankRefNo("");
            setReqBankName("");
        }
    }

    function deletePaymentCnCard(key) {
        setPayListDataCnCard(Common.arrayRemoveItem(payListDataCnCard, 'key', key));
        setRefreshCounter(refreshCounter + 1);
    }

    function handleAgentCnCardChange(v) {
        setReqAgentAllowed(v);
        if (v === "13") {
            setReqBankCode("59");
            setReqBankName("Avanse Postpaid");
        } else {
            setReqBankCode("0");
            setReqBankName("");
        }
    }

    function handleCnCardConfirmModal() {
        setMsgBoxYN(false);
        setOpenCnCardModal(true);
        if (reqAgentAllowed === "13") setPayListDataCnCard([]);
    }

    const downloadChargesFormate = () => {
        var object1 = {
            right: 'REMITTANCE_CHARGES_UPLOAD',
        }
        Common.callDownloadApiPost(Common.apiFormat, "post", [sid, 'DownloadUploadChargesFormate', JSON.stringify(object1)]);
    }

    const uploadCharge = () => {
        $('.loader').show();
        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0] === undefined) {

            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'REMITTANCECHANGESUPLOAD',
                    // srno: reqData.req_srno,
                    pageright: 'REMITTANCE_CHARGES_UPLOAD',
                    // docid: reqDocId,
                    // remark: reqDocRemark,
                    // reqCoverBank: reqCoverBank
                }
                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    let resp = JSON.parse(result);
                    $('.loader').hide();
                    setFile(null);
                    if (resp.error === "") {
                        alert(resp.message);
                        setShowUpload(false);
                    } else {
                        alert(resp.error);
                    }
                });
            }
        }
    }


    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >

                {
                    showFilter ?
                        <div >
                            <Row>
                                <Col>
                                    <h1>Remittance</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select
                                                        value={srchStatus}
                                                        onChange={(e) => onChangeSearchStatus(e.target.value)}  >
                                                        {ddReqStatusOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            {srchStatus === "BNKF" || srchStatus === "ACVN" ?
                                                <>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>Issuer </Form.Label>
                                                            <Form.Select
                                                                value={srchIssuer}
                                                                onChange={(e) => handleSetSrchIssuer(e.target.value)}  >
                                                                {ddSrchIssuer.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : <>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Search...<span className="handCursor colorThemeBlue" title="Help"
                                                                onClick={(e) => showSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                                            </span></Form.Label>
                                                            <Form.Control type="text" placeholder="Search..."
                                                                maxLength={50} autoComplete="off"
                                                                value={srchRef}
                                                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSrchRef)}
                                                                onKeyDown={(e) => handleKeyDown(e)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            }

                                            {
                                                (srchStatus === "NPROC" || srchStatus === "BNKF"
                                                    || srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR"
                                                    || srchStatus === "ACH" || srchStatus === "ADT" || srchStatus === "VPAY"
                                                    || srchStatus === "VCOMP" || srchStatus === "SNAVR" || srchStatus === "VBRCH"
                                                ) ?
                                                    <>
                                                        <Col>&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                    </>
                                                    :
                                                    <>
                                                        {srchRef === "" ?
                                                            <>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>From Date</Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={srchFromDate}
                                                                            onChange={(date) => setSrchFromDate(date)}
                                                                            isClearable
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>To Date</Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={srchToDate}
                                                                            onChange={(date) => setSrchToDate(date)}
                                                                            isClearable
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            :
                                                            <>
                                                                <Col>&nbsp;</Col>
                                                                <Col>&nbsp;</Col>

                                                            </>

                                                        }

                                                    </>
                                            }


                                        </Row>
                                        {
                                            srchRef === "" ?
                                                <>
                                                    <Row>
                                                        <Col>
                                                            &nbsp;
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        {
                                                            entityType === "B" ?
                                                                <>
                                                                    {
                                                                        /*
                                                                            <Col>
                                                                                <Form.Group>
                                                                                    <Form.Label>Branch<span className="mandatory">*</span></Form.Label>
                                                                                    <Form.Select
                                                                                        value={reqBranch}
                                                                                        onChange={(e) => setReqBranch(e.target.value)}
                                                                                        disabled={entityType === 'A' || ddReqBranchOptions.length === 2} >
                                                                                        {ddReqBranchOptions.map((res) =>
                                                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                                                        )}
                                                                                    </Form.Select>
                                                                                </Form.Group>
                                                                            </Col>
                                                                        */
                                                                    }

                                                                    <Col>
                                                                        <Form.Group>
                                                                            <Form.Label>Branch</Form.Label>
                                                                            <Select
                                                                                value={srchBranSelect}
                                                                                onChange={handleSrchBranchOptions}
                                                                                options={ddSrchBranOptions}
                                                                                isDisabled={ddSrchBranOptions.length === 2}
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col>
                                                                        <Form.Group>
                                                                            <Form.Label>Agent</Form.Label>
                                                                            <Form.Select
                                                                                value={reqAgent}
                                                                                onChange={(e) => setReqAgent(e.target.value)}
                                                                                disabled={entityType === 'A'} >
                                                                                {ddReqAgentOptions.map((res) =>
                                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                                )}
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </>
                                                                : null
                                                        }
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Purpose {entityType === "A" ? <span className="mandatory">*</span> : null} </Form.Label>
                                                                <Form.Select
                                                                    value={reqPurpose}
                                                                    onChange={(e) => setReqPurpose(e.target.value)}  >
                                                                    <input type="text" />
                                                                    {ddReqPurposeOptions.map((res) =>
                                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                                    )}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>&nbsp;</Col>

                                                        {
                                                            entityType === "A" ? <>
                                                                <Col>&nbsp;</Col>
                                                                <Col>&nbsp;</Col>

                                                            </> : null
                                                        }
                                                    </Row>

                                                </>
                                                : null
                                        }
                                        <Row>
                                            <Col>
                                                &nbsp;
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12}>
                                                <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => searchRequest(1)}>Search</Button>&nbsp;
                                                <Button variant="outline-danger" size="sm" onClick={() => resetSearch()}>Reset</Button>&nbsp;
                                                {
                                                    showDownloadBankFileButton ?
                                                        <>
                                                            <Button variant="outline-primary" size="sm" onClick={() => downloadBankFile()}>Bank File</Button>&nbsp;
                                                        </>

                                                        : null
                                                }
                                                {
                                                    rightEmailSwiftInvoice.query === "1" ? <>
                                                        <Button variant="outline-success" size="sm" onClick={() => autoInvoiceEmailRequest()}>Email Swift/Invoice</Button>&nbsp;
                                                    </> : null
                                                }

                                                {
                                                    entityType === "B" ? <>
                                                        <Button variant="outline-success" size="sm" onClick={() => handleShow()}>PAN Log</Button>&nbsp;
                                                    </> : null
                                                }

                                                {
                                                    rightSpecialApproval.query === "1" ? <>
                                                        <Button variant="outline-success" size="sm" onClick={() => goToSpecialApproval()}>Special Approval</Button>&nbsp;
                                                    </> : null
                                                }

                                                {
                                                    rightCnCard.query === "1" ? <>
                                                        <Button variant="outline-success" size="sm" onClick={() => goToCnCard()}>CN/CARD</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    uploadRight.query === "1" ? <>
                                                        <Button variant="outline-success" size="sm" onClick={() => setShowUpload(true)}>Upload</Button>&nbsp;
                                                    </> : null
                                                }
                                                <input
                                                    type="checkbox"
                                                    checked={srchAutoRefresh}
                                                    onChange={handleAutoRefresh}
                                                />
                                                &nbsp;Auto Refresh (30 seconds)&nbsp;
                                                <input
                                                    type="checkbox"
                                                    checked={srchExtraDetails}
                                                    onChange={handleExtraDetails}
                                                />
                                                &nbsp;Status

                                            </Col>

                                        </Row>
                                        {showUpload &&
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group controlId="fileToUpload">
                                                        <Form.Label>Upload File<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control type="file" value={file} onChange={e => setFile(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <span>
                                                            <Badge bg="secondary" className="handCursor" onClick={downloadChargesFormate}>Download Charges Formate</Badge>
                                                        </span><br></br> <br></br>
                                                        <Button variant="outline-success" className='buttonStyle' size='sm' onClick={uploadCharge}>Submit</Button>{' '}
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                    </div>
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            {
                                srchStatus === "ACVN" && tranListData.length > 0 ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Button variant="outline-primary" size="sm" onClick={() => calcSummary()}>Summary</Button>&nbsp;
                                                CASH:&nbsp;{sessionStorage.coverCashValidity}&nbsp;TOM:&nbsp;{sessionStorage.coverTomValidity}&nbsp;SPOT:&nbsp;{sessionStorage.coverSpotValidity}
                                                &nbsp;<span className="handCursor" onClick={() => changeCoverValidityDate()} >&nbsp;&nbsp;<Badge bg="danger">Change</Badge></span>
                                            </Col>
                                        </Row>
                                    </> : null
                            }
                            <Row>
                                <Col className='col-md-1 col-2'>
                                    <Form.Check checked={filterTTCheck} type='checkbox' label='TT/DD' onChange={(e) => setFilterTTCheck(e.target.checked)} />
                                </Col>
                                <Col className='col-md-1 col-2' >
                                    <Form.Check checked={filterCnCardCheck} type='checkbox' label='CN/CARD' onChange={(e) => setFilterCnCardCheck(e.target.checked)} />
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>

                            {/** Table */}
                            <Row>
                                <Col>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>Action</td>
                                                {showDownloadBankFileButton ?
                                                    <>
                                                        <td><input type="checkbox" onChange={(e) => selectAllToggle(e.target.checked)} /></td>

                                                    </>

                                                    : null}
                                                {
                                                    srchStatus === "BNKF" || srchStatus === "VPAY" || srchStatus === "VCOMP" || srchStatus === "SNAVR" ? <>
                                                        <td>Time</td>
                                                    </> : null
                                                }
                                                <td>Sr. No.</td>
                                                <td>Reference No</td>
                                                <td>User</td>
                                                <td>Branch</td>
                                                <td>Agent</td>
                                                <td>Purpose</td>
                                                {
                                                    (srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR") ? null :
                                                        <>
                                                            <td>Remitter Name</td>
                                                        </>
                                                }
                                                <td>Product</td>
                                                <td>Currency</td>
                                                <td>Quantity</td>
                                                <td>Tenure</td>
                                                <td>Sale Rate</td>
                                                {
                                                    (srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR") ? <>
                                                        <td>Bank</td>
                                                        <td>Type</td>
                                                    </>
                                                        :
                                                        <>
                                                            {
                                                                entityType === "A" && noCoverViewAgent() ?
                                                                    <>
                                                                    </> : <>
                                                                        <td>Cover Rate</td>
                                                                    </>
                                                            }

                                                            {entityType === "B" ? <td>Bank Rate</td> : null}
                                                        </>
                                                }
                                                <td className='divHide'>Status</td>

                                                {
                                                    entityType === "B" && srchExtraDetails ?
                                                        <td>Covered</td>
                                                        : null
                                                }
                                                {
                                                    srchExtraDetails ?
                                                        <>
                                                            <td>Charges</td>
                                                            <td>Fund</td>
                                                            <td>Checker</td>
                                                            <td>Bank</td>
                                                            <td>Swift</td>
                                                        </> : null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody id="searchList">
                                            {/** First Row */}
                                            {tranListData.map((res) =>
                                                <>
                                                    <tr key={res.req_refno} >
                                                        <td>
                                                            <>


                                                                <span className="handCursor colorThemeBlue"
                                                                    title="View Details"
                                                                    onClick={(e) => showPrintPreviewWindow(res.req_srno)}
                                                                >
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>&nbsp;&nbsp;

                                                                {
                                                                    rightCoverrate.query === "1" && res.req_status === "1" ?
                                                                        <span className={res.req_coverfinal === "1" ? "colorThemeBlue" : "colorThemeRed"}
                                                                            title="Add Cover"
                                                                            onClick={(e) => showCoverWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor"  >
                                                                                <FontAwesomeIcon icon={faRupeeSign} />
                                                                            </span>&nbsp;&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    rightTcsUpdate.query === "1" && res.req_status === "1" ?
                                                                        <span className={res.req_tcsfinal === "1" ? "colorThemeBlue" : "colorThemeRed"}
                                                                            title="Add Charges"
                                                                            onClick={(e) => showTcsGstWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor"  >
                                                                                <FontAwesomeIcon icon={faEdit} />
                                                                            </span>&nbsp;&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    (rightAddDetails.query === "1" && res.req_tcsfinal === "1" && res.req_status === "1") ?
                                                                        <span className={(res.req_adddetailsfinal === "0" || res.req_paymentfinal === "0" || res.req_documentsfinal === "0") ? "colorThemeRed" : "colorThemeBlue"}

                                                                            title="Add Details"
                                                                            onClick={(e) => showAddMoreDtlWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faShareSquare} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    (rightBranchDetailsVerify.query === "1" && res.req_documentsfinal === "1" && res.req_adddetailsfinal === "1" && res.req_status === "1") ?
                                                                        <span className={(res.req_branchdetailsverify === "0") ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="Branch Details Verify"
                                                                            onClick={(e) => showBranchDetailsVerifyWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                {/* <FontAwesomeIcon icon={byPrefixAndName.fas['check-double']} /> */}
                                                                                <FontAwesomeIcon icon={faCheckDouble} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    rightBmaprove.query === "1"
                                                                        && res.req_documentsfinal === "1" && res.req_adddetailsfinal === "1" && res.req_status === "1" ?
                                                                        <>
                                                                            <span
                                                                                className={(res.req_bmapproval === "0") ? "colorThemeRed handCursor" : "colorThemeBlue handCursor"}
                                                                                title="BM Approval"
                                                                                onClick={(e) => showBmApprovalWindow(res.req_srno)} >
                                                                                <b>&nbsp;BM&nbsp;</b>
                                                                            </span>
                                                                        </>
                                                                        : null
                                                                }
                                                                {
                                                                    rightZmaprove.query === "1" && res.req_documentsfinal === "1" && res.req_adddetailsfinal === "1" && res.req_status === "1" ?
                                                                        <>
                                                                            <span
                                                                                className={(res.req_zmapproval === "0") ? "colorThemeRed handCursor" : "colorThemeBlue handCursor"}
                                                                                title="ZM Approval"
                                                                                onClick={(e) => showZmApprovalWindow(res.req_srno)} >
                                                                                <b>&nbsp;ZM&nbsp;</b>
                                                                            </span>
                                                                        </>
                                                                        : null
                                                                }
                                                                {
                                                                    rightBhaprove.query === "1" && res.req_documentsfinal === "1" && res.req_adddetailsfinal === "1" && res.req_status === "1" ?
                                                                        <>
                                                                            <span
                                                                                className={(res.req_bhapproval === "0") ? "colorThemeRed handCursor" : "colorThemeBlue handCursor"}
                                                                                title="BH Approval"
                                                                                onClick={(e) => showBhApprovalWindow(res.req_srno)} >
                                                                                <b>&nbsp;BH&nbsp;</b>
                                                                            </span>
                                                                        </>
                                                                        : null
                                                                }
                                                                {
                                                                    (rightPayApprove.query === "1" && res.req_paymentfinal === "1" && res.req_status === "1" && res.req_branchdetailsverify === "1") ?
                                                                        <span className={(res.req_paymentapproved === "0") ? "colorThemeRed" : "colorThemeBlue"}

                                                                            title="Verify Payment"
                                                                            onClick={(e) => showPaymentApprovalWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faMoneyBill} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    (rightComplianceApprove.query === "1" && res.req_documentsfinal === "1" && res.req_adddetailsfinal === "1" && res.req_status === "1" && res.req_branchdetailsverify === "1") ?
                                                                        <span className={(res.req_complianceapproved === "0") ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="Verify Details"
                                                                            onClick={(e) => showComplianceApprovalWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faClipboardCheck} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    (rightBankFileApprove.query === "1" && res.req_paymentapproved === "1" && res.req_complianceapproved === "1" && res.req_coverfinal === "1" && res.req_status === "1") ?
                                                                        <span className={(res.req_bankfilegenrated === "0") ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="Bank File"
                                                                            onClick={(e) => showBankFileDownWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faUniversity} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    (res.req_bank * 1 === 10 && rightApiMaker.query === "1" && rightBankFileApprove.query === "1" && res.req_paymentapproved === "1" && res.req_complianceapproved === "1" && res.req_coverfinal === "1" && res.req_status === "1") ?
                                                                        <span className={(res.req_bankfilegenrated === "0") ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="API"
                                                                            onClick={(e) => showApiVerificationWindow(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faPlane} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {   // && res.req_bankfilegenrated === "1"
                                                                    ((rightSwiftUpload.query === "1" || rightInvoiceUpload.query === "1") && res.req_status === "1") ?
                                                                        <span className={(res.req_swiftuploaded === "1" && res.req_invoiceuploaded === "1") ? "colorThemeBlue" : ((res.req_swiftuploaded === "1" && res.req_invoiceuploaded === "0") ? " " : "colorThemeRed")}
                                                                            title="Upload Final Documents"
                                                                            onClick={(e) => showFinalDocumentUpload(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faCloudUploadAlt} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                                {
                                                                    ((rightSwiftDownload.query === "1" || rightInvoiceDownload.query === "1") && (res.req_swiftuploaded === "1" || res.req_invoiceuploaded === "1") && res.req_status === "1") ?
                                                                        <span className={"colorThemeBlue"}
                                                                            title="Download Final Documents"
                                                                            onClick={(e) => showFinalDocumentDownload(res.req_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faCloudDownloadAlt} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                        : null
                                                                }
                                                            </>
                                                        </td>
                                                        {
                                                            showDownloadBankFileButton ?
                                                                <>
                                                                    <td><input type="checkbox" value={res.req_srno} className="selectorChkBox" /></td>
                                                                </>
                                                                : null
                                                        }
                                                        {
                                                            srchStatus === "BNKF" ?
                                                                <>
                                                                    <td>{(res.req_lastupdatetimestamp + '000000000000000000').substring(11, 16)}</td>
                                                                </> : <>
                                                                    {(srchStatus === "VPAY" || srchStatus === "VCOMP" || srchStatus === "SNAVR") ?
                                                                        <td>{(res.req_additionaldetail_final_timestamp + '000000000000000000').substring(11, 16)}</td>
                                                                        : null}
                                                                </>
                                                        }

                                                        <td className="textRight">{res.req_srno}
                                                            {res.req_version * 1 === 1 && srchStatus === "ACVN" ?
                                                                <><input type="hidden" className="ACVNSummary" value={res.req_isd + '^' + res.req_tenure + '^' + res.req_quantity}></input></> : null}

                                                        </td>
                                                        <td className={res.req_status === "0" ? 'bg-danger text-white' : (res.req_bankfilegenrated === "0" ? 'bg-info text-white' : 'bg-success text-white')}>{res.req_refno}</td>
                                                        <td>{res.req_username}</td>
                                                        <td>{res.req_brnnm}</td>
                                                        <td className={res.req_agentapisubmit === "1" ? 'bg-danger text-white' : ''}>{res.req_agnnm} {res.mel_location}</td>
                                                        <td>{res.purpose_name}</td>
                                                        {
                                                            (srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR") ? null : <>
                                                                <td>{res.req_remittername} {res.req_pan === "" ? null : <>({res.req_pan})</>} </td>
                                                            </>
                                                        }
                                                        <td className={res.req_productcode === "DD" ? 'bg-danger text-white' : null}
                                                        >{res.req_productcode}</td>
                                                        <td className={(srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR")
                                                            && res.cover_bank !== "0" ? 'bg-danger text-white' : null} >{res.req_isd}</td>
                                                        <td className={(srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR")
                                                            && res.cover_bank !== "0" ? 'bg-danger text-white' : null} >{res.req_quantity}</td>
                                                        <td
                                                            className={(res.cover_date === "0" || res.req_bankfilegenrated === "1") ? "" : (todayDateNum === res.cover_date.replace('-', '').replace('-', '') ? "bg-warning text-white" : (todayDateNum > res.cover_date.replace('-', '').replace('-', '') ? "bg-danger text-white" : ""))}
                                                        >{res.req_tenure}</td>
                                                        <td>{res.req_sellrate}</td>
                                                        {
                                                            (srchStatus === "ACV" || srchStatus === "ACVN" || srchStatus === "ACVR") ? <>
                                                                <td
                                                                    className={res.req_bank * 1 === 9 ? 'bg-danger text-white' : (res.req_bank * 1 === 10 ? "bg-warning text-dark" : (res.req_bank * 1 === 5 ? "bg-success text-white" : ""))}

                                                                >{res.issuer_name}</td>
                                                                <td className={res.req_version * 1 > 1 ? 'bg-danger text-white' : ""} >{res.req_version === "1" ? "New" : "Revised"}</td>
                                                            </> :
                                                                <>
                                                                    {
                                                                        entityType === "A" && noCoverViewAgent() ? <>
                                                                        </> : <>
                                                                            <td>{res.req_agentcover}</td>
                                                                        </>
                                                                    }

                                                                    {entityType === "B" ? <td>{res.req_issuercover}</td> : null}
                                                                </>
                                                        }
                                                        <td className='divHide'>{res.status_description}</td>

                                                        {
                                                            entityType === "B" && srchExtraDetails ?
                                                                <td>
                                                                    {res.req_coverfinal === "1" ? "Yes" : ""}
                                                                </td>
                                                                : null
                                                        }
                                                        {
                                                            srchExtraDetails ? <>
                                                                <td>
                                                                    {res.req_tcsfinal === "1" ? "Yes" : ""}
                                                                </td>
                                                                <td>
                                                                    {res.req_paymentapproved === "1" ? "Yes" : ""}
                                                                </td>
                                                                <td>
                                                                    {res.req_complianceapproved === "1" ? "Yes" : ""}
                                                                </td>
                                                                <td>
                                                                    {res.req_bankfilegenrated === "1" ? "Yes" : ""}
                                                                </td>
                                                                <td>
                                                                    {res.req_swiftuploaded === "1" ? "Yes" : ""}
                                                                </td>
                                                            </> : null
                                                        }
                                                    </tr>
                                                    {
                                                        (srchStatus === "ACVN" && res.req_version * 1 === 1
                                                            && rightCoverrate.add === "1" && res.cover_bank === "0") ?
                                                            <>
                                                                <tr >

                                                                    <td colSpan={14} style={{ textAlign: 'center' }}>
                                                                        {res.req_tenure}&nbsp;&nbsp;

                                                                        <input disabled id={"DealIdValDt" + res.req_srno} value={(res.req_tenure === "CASH" ? sessionStorage.coverCashValidity : (res.req_tenure === "TOM" ? sessionStorage.coverTomValidity : (res.req_tenure === "SPOT" ? sessionStorage.coverSpotValidity : res.req_valuedate)))}></input>
                                                                        &nbsp;&nbsp;<input type="hidden" id={"DealTenure" + res.req_srno} value={res.req_tenure}></input>
                                                                        <input type="hidden" id={"DealBankId" + res.req_srno} value={res.req_bank}></input>
                                                                        <input type="hidden" id={"DealQty" + res.req_srno} value={res.req_quantity}></input>

                                                                        <input type="text" className="QuickDeal" id={"DealId" + res.req_srno} placeholder="Deal ID"></input>&nbsp;&nbsp;&nbsp;&nbsp;

                                                                        <input type="text" className="QuickDeal" id={"DealRate" + res.req_srno} placeholder="Deal Rate"
                                                                            maxLength={20} autoComplete="off"
                                                                        ></input>&nbsp;&nbsp;&nbsp;&nbsp;
                                                                        <Button onClick={() => quickCoverFinal(res.req_srno)}>Final Cover</Button>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                            : null
                                                    }

                                                </>

                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                        : null
                }
                {
                    showCvr ?
                        <CoverRate srno={modalRef} callInProgress={showFilterWindow}></CoverRate>
                        : null
                }
                {
                    showAddTcsGst ?
                        <TcsGstCharges srno={modalRef} callInProgress={showFilterWindow} ></TcsGstCharges>
                        : null
                }
                {
                    showAddMoreDtl ?
                        <AddDetails srno={modalRef} callInProgress={showFilterWindow} ></AddDetails>
                        : null
                }
                {
                    showPaymentApproval ?
                        <PaymentApproval srno={modalRef} callInProgress={showFilterWindow} ></PaymentApproval>
                        : null
                }
                {
                    showComplianceApproval ?
                        <ComplianceApproval srno={modalRef} callInProgress={showFilterWindow} ></ComplianceApproval>
                        : null
                }
                {
                    showBranchDetailsVerify ?
                        <BranchDetailVerify srno={modalRef} callInProgress={showFilterWindow} ></BranchDetailVerify>
                        : null
                }
                {
                    showBankFileDown ?
                        <BankFile srno={modalRef} callInProgress={showFilterWindow} ></BankFile>
                        : null
                }
                {
                    showApiVerification ?
                        <ApiMaker srno={modalRef} callInProgress={showFilterWindow} ></ApiMaker>
                        : null
                }
                {
                    showUploadDocument ?
                        <UploadSwift srno={modalRef} callInProgress={showFilterWindow} ></UploadSwift>
                        : null
                }
                {
                    showDownloadDocument ?
                        <DownloadSwift srno={modalRef} callInProgress={showFilterWindow} ></DownloadSwift>
                        : null
                }
                {
                    showPrintPreview || showBmApproval || showZmApproval || showBhApproval ?
                        <>
                            <ShowPrintPreview srno={modalRef} callInProgress={showFilterWindow} ></ShowPrintPreview>
                        </>
                        : null
                }
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>

            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <Dialog isOpen={isMsgBoxCnCard} onClose={(e) => { setMsgBoxCnCard(false); setOpenCnCardModal(true) }}>
                    {msgTextCnCard}
                </Dialog>
            </div>
            <Modal show={openConfirmBox} backdrop="static" centered onHide={() => setOpenConfirmBox(false)}>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{confirmBoxMsg}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col>
                            <Button size='sm' variant="secondary" className='btn_admin' onClick={() => setOpenConfirmBox(false)}>No</Button>
                            &nbsp;
                            <Button size='sm' variant="success" className='btn_admin' onClick={() => handleConfirmBox()}>Yes</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>


            <Modal show={show} onHide={handleClose} centered>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form.Group >
                                <Form.Label>PAN</Form.Label>
                                <p style={{ color: 'red', fontSize: '13px' }}>{message}</p>
                                <Form.Control type="text" placeholder="PAN" maxLength={10}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setPanNum)}
                                    value={panNum} autoComplete="off" />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button size='sm' variant="primary" onClick={() => fetchPanData()}>
                        Fetch PAN
                    </Button>
                    <Button size='sm' variant="secondary" onClick={handleClose}>
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>

            <Modal show={showPanData} onHide={handleClosePan} size='xl'>
                <Modal.Header >
                    <Modal.Title>PAN:  {panNum}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        <Table striped bordered hover>

                            <tbody>
                                <tr>
                                    <td>Id</td>
                                    <td>Time</td>
                                    <td>Name</td>
                                    <td>Name Status</td>
                                    <td>DOB</td>
                                    <td>DOB Status</td>
                                </tr>
                                {
                                    panLog.map(item => (
                                        <tr>
                                            <td>{item.pv_apitransactionid}</td>
                                            <td>{item.pv_timestamp}</td>
                                            <td>{JSON.parse(item.pv_request)[0].name}</td>
                                            <td>{JSON.parse(item.pv_response).outputData[0].name == 'Y' ? 'YES' : 'NO'}</td>
                                            <td>{JSON.parse(item.pv_request)[0].dob}</td>
                                            <td>{JSON.parse(item.pv_response).outputData[0].dob == 'Y' ? 'YES' : 'NO'}</td>
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClosePan}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={openChangeCoverValidity} backdrop="static" centered onHide={() => setOpenChangeCoverValidity(false)}>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>Change Booking Validity Date</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>CASH Expiry</Form.Label>
                                <DatePicker className="form-control"
                                    selected={cashDate}
                                    onChange={(date) => setCashDate(date)}
                                    isClearable
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>TOM Expiry</Form.Label>
                                <DatePicker className="form-control"
                                    selected={tomDate}
                                    onChange={(date) => setTomDate(date)}
                                    isClearable
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>SPOT Expiry</Form.Label>
                                <DatePicker className="form-control"
                                    selected={spotDate}
                                    onChange={(date) => setSpotDate(date)}
                                    isClearable
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col>
                            <Button size='sm' variant="success" className='btn_admin' onClick={() => handleChangeCoverValidity()}>Change</Button>
                            &nbsp;
                            <Button size='sm' variant="secondary" className='btn_admin' onClick={() => setOpenChangeCoverValidity(false)}>Exit</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={openCnCardModal} backdrop="static" size='xl' onHide={() => setOpenCnCardModal(false)}>
                <Modal.Body>
                    <Row>
                        <Col>
                            <h2>CN/CARD</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group >
                                <Form.Label>Request Date<span className="mandatory">*</span></Form.Label>
                                <DatePicker className="form-control"
                                    selected={reqDateCnCard}
                                    onChange={(date) => setReqDateCnCard(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Branch<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqBranchAllowed}
                                    onChange={(e) => handleBranchChangeCnCard(e.target.value)}
                                    disabled={ddReqBranchOptionsAllowed.length === 2} >
                                    {ddReqBranchOptionsAllowed.map((res) =>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group >
                                <Form.Label>Reference<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqReference}
                                    onChange={(e) => onChangeRefrence(e.target.value)}
                                    disabled >
                                    <option value="S">Self</option>
                                    <option value="A">Agent</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqAgentAllowed}
                                    onChange={(e) => handleAgentCnCardChange(e.target.value)}
                                    disabled={entityType === 'A'} >
                                    {ddReqAgentOptionsAllowed.map((res) =>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group >
                                <Form.Label>Inovice Amount<span className="mandatory">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Invoice Amount" maxLength={10}
                                    onChange={(e) => Common.validateDecValue(e.target.value, setInvAmountCnCard)}
                                    value={invAmountCnCard} autoComplete="off" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='divHide'>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Product<span className="mandatory">*</span></Form.Label>
                                <Form.Select
                                    value={reqProductCnCard}
                                    onChange={(e) => setReqProductCnCard(e.target.value)}  >
                                    <option value="CNCARD">CNCARD</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <h5>Loan Related Details</h5>
                    </Row>
                    <Row>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Account No {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Account No" maxLength={50} autoComplete="off"
                                    value={reqLoanAccountNo}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqLoanAccountNo)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Applicant {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicant}
                                    onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanApplicant)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Applicant Passport {reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant Passport" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicantPassport}
                                    onChange={(e) => setReqLoanApplicantPassport(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Applicant Pan{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Applicant Pan" maxLength={50} autoComplete="off"
                                    value={reqLoanApplicantPan}
                                    onChange={(e) => setReqLoanApplicantPan(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Co Applicant{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co Applicant" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicant}
                                    onChange={(e) => Common.validateAlpNumSpl1Value(e.target.value, setReqLoanCoApplicant)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Co App Passport{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co App Passport" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicantPassport}
                                    onChange={(e) => setReqLoanCoApplicantPassport(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3'>
                            <Form.Group>
                                <Form.Label>Loan Co App Pan{reqAgentAllowed === "13" && <span className="mandatory">*</span>}</Form.Label>
                                <Form.Control type="text" placeholder="Loan Co App Pan" maxLength={50} autoComplete="off"
                                    value={reqLoanCoApplicantPan}
                                    onChange={(e) => setReqLoanCoApplicantPan(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col>
                            <h5>Payment Details</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>Bank </Form.Label>
                                <Form.Select
                                    value={reqPayBankCode}
                                    onChange={(e) => handleReqPayBank(e.target.value, e.target.options[e.target.selectedIndex].text)}
                                    disabled={reqAgentAllowed === "13"}
                                >
                                    {ddReqPayBankOptions.map((res) =>
                                        <option key={res.value} value={res.value}>{res.name}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {
                            reqAgentAllowed !== "13" &&
                            <>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Bank Reference No</Form.Label>
                                        <Form.Control type="text" placeholder="Reference Number"
                                            maxLength={50} autoComplete="off"
                                            value={reqPayBankRefNo}
                                            disabled={reqAgentAllowed === "13"}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqPayBankRefNo)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>INR Amount</Form.Label>
                                        <Form.Control type="text" placeholder="INR Amount"
                                            maxLength={10} autoComplete="off"
                                            value={reqPayBankAmnt}
                                            disabled={reqAgentAllowed === "13"}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqPayBankAmnt)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Date<span className="mandatory">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={reqPayBankDate}
                                            onChange={(date) => setReqPayBankDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                            }
                                            disabled={reqAgentAllowed === "13"}
                                        />
                                    </Form.Group>
                                </Col>
                            </>
                        }
                    </Row>
                    {
                        reqAgentAllowed !== "13" &&
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>&nbsp;</Form.Label><br></br>
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnAddPayment()} >Add</Button>
                                </Form.Group>
                            </Col>
                        </Row>
                    }
                    {
                        payListDataCnCard.length > 0 &&
                        <Row>
                            <Col>
                                <Table responsive striped bordered>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Bank</th>
                                            <th>Ref no</th>
                                            <th>Amount</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            payListDataCnCard.map((item, index) => (
                                                <tr>
                                                    <td>
                                                        <span className='handCursor colorThemeBlue' onClick={() => deletePaymentCnCard(item.key)}>
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </span>
                                                    </td>
                                                    <td>{item.pay_bankcode + " " + item.pay_bankname}</td>
                                                    <td>{item.pay_refno}</td>
                                                    <td>{item.pay_amnt}</td>
                                                    <td>{item.pay_date}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col>
                            <Button size='sm' variant="success" className='btn_admin' onClick={() => onSubmitCnCard()}>Submit</Button>
                            &nbsp;
                            <Button size='sm' variant="secondary" className='btn_admin' onClick={() => { setOpenCnCardModal(false); resetCnCardModal() }}>Cancel</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => saveDataCnCard()} onNo={(e) => handleCnCardConfirmModal()}>
                {msgTextYN}
            </DialogYesNo>
        </>
    );
}
export default InProgress;